





















































































































































import {Component, Watch, Prop} from 'vue-property-decorator';
import Form, { Send, TranslateErrorsOptions } from '@/components/form-base';
import LandingApi from '@/services/rest/bemob/landing';
import TagApi from '@/services/rest/bemob/tag';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import tutorial from '@/components/tutorial/tutorial';
import availableTokens from '@/views/reports/forms/landing/config/availableTokens';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import { throttle } from 'lodash';

import dialogTargetMock from '@/components/dialogs/dialog-target-mock';
import {mixins} from 'vue-class-component';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import TutorialMixin from '@/components/tutorial/tutorial-mixin';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import ApiServices from '@/services';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

const md5 = require('md5');

@Component({
  components: {
    ErrorAggregator,
    HeaderButtons,
    WorkspaceSelect,
    NoTagFound
  }
})
export default class CreateLandingDialog extends mixins<PlanLimitsMixin, Form, ReportMixin, TutorialMixin>(PlanLimitsMixin, Form, ReportMixin, TutorialMixin) {
  @Prop({ default: {} })
  data: any;
  tagApi: TagApi = new TagApi();

  show: boolean = false;
  landing_id: string = '';
  landingApi: LandingApi = new LandingApi();
  step: number = 1;
  loading: boolean = false;
  disableWorkspaceSelect: boolean = false;

  errors: any[] = [];
  errorsControlActive: boolean = false;
  emptyUrlSend: boolean = false;

  dialogTargetMock = dialogTargetMock();

  form: any = this.defaultForm();

  get modalTitle(){
    return this.t('Create Landing')
  }

  get introStepsDefault() {
    return {
      2: `<div class='introjs-tooltip__title'>${this.t('Landing Page Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify name of landing page')}</div>`,
      3: `<div class='introjs-tooltip__title'>${this.t('Landing Page Settings')}</div><div class='introjs-tooltip__content'>${this.t('Enter the URL of landing page')}</div>`,
      4: `<div class='introjs-tooltip__title'>${this.t('Landing Page Settings')}</div><div class='introjs-tooltip__content'>${this.t('Create landing page element')}</div>`
    };
  }

  get quickStartSection() {
    return 'landings';
  }

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.landing_id,
      type: 'landings',
    }))
  }

  defaultForm() {
    return {
      status: 'active',
      countryId: 0,
      url: '',
      offers: 1
    };
  }

  get disabledChips() {
    return [ '+ {clickId}' ];
  }

  get chips() {
    return availableTokens
      .filter((e) => this.disabledChips.indexOf(e) === -1)
      .map((e) => ({
        tag: e,
        disabled: false
      }));
  }

  get countryListPlusGlobal() {
    return this.$store.getters.countryListPlusGlobal;
  }

  get countryName() {
    return this.form.countryId && this.countryListPlusGlobal.find((e: any) => e.id === this.form.countryId).name;
  }

  get tutorial() {
    return tutorial(this);
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  get nameDescriptionCountryName() {
    return this.countryName || this.t('Global');
  }

  get nameDescriptionName() {
    return this.form.name || this.t('None');
  }

  get nameDescription() {
    return `${this.nameDescriptionCountryName} - ${this.nameDescriptionName}`;
  }

  get translateErrorsConfig(): TranslateErrorsOptions {
    let translate: any = {};

    if(this.emptyUrlSend) {
      translate['url'] = {
        VALIDATION_INVALID_URL: 'CUSTOM_VALIDATION_EMPTY_URL'
      }
    }

    return { translate };
  }

  loadData() {
    const {workspaceId} = this.data;
    this.$store.commit('loading', true);

    return this.load()
      .then(() => {
        this.tutorial.form();
        this.oldHash = this.getCurrentHash();
        this.show = true;

        if(workspaceId){
          this.form.workspaceId = workspaceId
          this.disableWorkspaceSelect = true;
        }
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }

  async mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message, this.translateErrorsConfig);
      this.errorsControlActive = true;
    });

    if(!this.$store.state.cache.tags.landings.isUploaded){
      await this.tagApi.populateStoreCache({type:'landings'})
    }
    
    this.loadData()
  }

  @Watch('active')
  onActiveChanged(value: boolean) {
    this.$helpers.afterBrowserRedraw(() => {
      const scrollPanel = this.$refs.scrollPanel as any;
      const scrollPanelWrapper = this.$refs.scrollPanelWrapper as any;

      if(scrollPanel) {
        if(value) {
          scrollPanel.addEventListener('scroll', this.onDialogScrollThrottled);
          scrollPanelWrapper.addEventListener('scroll', this.onDialogScrollThrottled);
        } else {
          scrollPanel.removeEventListener('scroll', this.onDialogScrollThrottled);
          scrollPanelWrapper.removeEventListener('scroll', this.onDialogScrollThrottled);
        }
      }
    });
  }

  onDialogScroll() {
    this.bus.emit('dialog-scroll', 'landing-dialog');
  }

  get onDialogScrollThrottled() {
    return throttle(this.onDialogScroll, 10);
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
  }

  processForm(form: any) {
    const preparedForm = {...form}
    preparedForm.tags = preparedForm?.tags?.map((item)=>item?.id ? item.name : item);
    return preparedForm;
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    this.emptyUrlSend = !this.form.url;

    return this.landingApi.postCreate(this.processForm(this.form))
      .then(async (res) => {
        await ApiServices.getUserProfile();

        this.oldHash = this.getCurrentHash();

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Landing has been saved'));
        this.close();
        this.data?.onClose?.(res)
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }
  /* rewrite  method from mixin*/
  onChangeWorkspace(value: any) {}

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsLandings')
  }

  clearTags(){
    this.form.tags = []
  }
}
